<div class="flex items-center gap-4">
  @for (item of socialMediaLinks(); track item.id) {
    <app-external-link [link]="item.link">
      <app-header-icon [icon]="item.icon" />
    </app-external-link>
  }
</div>
